<!--
  OrgSelector — 기관 관리 화면 상단 공통 바
  · 내가 Master 인 기관이 여럿이면 셀렉터로 고른다(하나면 이름만). 선택은 organization 스토어에 보관해 두 화면이 공유
  · 진입 시 GET /voucher/org/me 를 다시 불러 잔액을 최신화한다(실패해도 표시는 유지)
-->
<template>
  <a-card padding="14" class="p-orgbar">
    <div class="p-orgbar__row">
      <div class="p-orgbar__icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <path d="M9 21v-8h6v8M7 7h.01M12 7h.01M17 7h.01M7 11h.01M12 11h.01M17 11h.01" />
        </svg>
      </div>
      <div class="p-orgbar__info">
        <select
          v-if="organizations.length > 1"
          class="p-input p-select p-orgbar__select"
          :value="current ? current.organization_idx : ''"
          @change="onChange"
        >
          <option v-for="o in organizations" :key="o.organization_idx" :value="o.organization_idx">{{ o.name }}</option>
        </select>
        <div v-else class="p-orgbar__name">{{ current ? current.name : '-' }}</div>
        <div class="p-orgbar__sub">
          <span v-if="current && current.name_en">{{ current.name_en }} · </span>기관 Master
          <span v-if="organizations.length > 1"> · {{ organizations.length }}개 기관</span>
        </div>
      </div>
      <div class="p-orgbar__stats">
        <div class="p-orgbar__stat">
          <span class="p-orgbar__label">바우처 잔액</span>
          <span class="p-orgbar__value">{{ current ? fmtAmount(current.voucher_balance, current.voucher_currency) : '-' }}</span>
        </div>
        <div class="p-orgbar__stat">
          <span class="p-orgbar__label">기관 할인</span>
          <span class="p-orgbar__value">{{ current && current.voucher_discount_rate != null ? current.voucher_discount_rate + '%' : '-' }}</span>
        </div>
      </div>
    </div>
  </a-card>
</template>

<script>
import ACard from '@/components/Pineapple/ACard.vue';
import { fmtAmount } from '../orgUtils';

export default {
  name: 'OrgSelector',
  components: { ACard },
  emits: ['change'],
  computed: {
    organizations() { return this.$store.getters['organization/organizations']; },
    current() { return this.$store.getters['organization/current']; },
  },
  mounted() {
    this.$store.dispatch('organization/refresh');
  },
  methods: {
    fmtAmount,
    onChange(e) {
      const idx = Number(e.target.value);
      this.$store.dispatch('organization/select', idx);
      this.$emit('change', idx);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_pineapple.scss';

.p-orgbar { margin-bottom: 16px; }
.p-orgbar__row {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.p-orgbar__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: $p-point-soft;
  color: $p-point-deep;
  display: grid;
  place-items: center;
  flex-shrink: 0;
}
.p-orgbar__info { flex: 1; min-width: 200px; }
.p-orgbar__name { font-size: 15px; font-weight: 800; color: $p-ink; }
.p-orgbar__sub { font-size: 11px; color: $p-ink-soft; margin-top: 2px; }
.p-orgbar__select { max-width: 360px; font-weight: 700; }
.p-orgbar__stats { display: flex; gap: 24px; }
.p-orgbar__stat { display: flex; flex-direction: column; gap: 2px; text-align: right; }
.p-orgbar__label { font-size: 10px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; color: $p-ink-soft; }
.p-orgbar__value { font-family: $p-font-mono; font-size: 14px; font-weight: 700; color: $p-ink; }
</style>
